var getFathom = function getFathom() {
  return window.fathom = window.fathom || function () {
    (window.fathom.q = window.fathom.q || []).push(arguments);
  };
};

var load = function load() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '//cdn.usefathom.com/tracker.js';

  window.fathom = window.fathom || function () {
    (window.fathom.q = window.fathom.q || []).push(arguments);
  };

  var tracker = document.createElement('script');
  var firstScript = document.getElementsByTagName('script')[0];
  tracker.async = true;
  tracker.src = url;
  tracker.id = 'fathom-script';
  firstScript.parentNode.insertBefore(tracker, firstScript);
};
var setSiteId = function setSiteId(siteId) {
  var fathom = getFathom();
  fathom('set', 'siteId', siteId);
};
var trackPageview = function trackPageview() {
  var fathom = getFathom();
  fathom('trackPageview');
};
var trackGoal = function trackGoal(id, cents) {
  var fathom = getFathom();
  fathom('trackGoal', id, cents);
};

export { load, setSiteId, trackGoal, trackPageview };
